<template>
  <div class="box">
    <!-- {{lines}} -->
    <div v-for="(line, index) in lines" :key="`multi_line_${index}`">
      <div
        v-if="line"
        :class="'line ' + line + '-line'"
        :style="{ background: color }"
      >
        <p
          v-show="line === 'bottom-left' && !isBlackListedId"
          class="data-value"
          :style="{ color: color }"
          v-html="dataValue"
        ></p>
        <div class="inner" :style="{ background: color }">
          <div
            class="inner-arrow"
            v-for="i in 4"
            :key="`${line}_${i}`"
            :class="line.split('-')[1]"
            :style="{ 'border-color': color }"
          ></div>
        </div>

        <div
          class="inner-circle"
          v-for="i in 4"
          :key="`multi_${line}_${i}`"
          :style="{
            'background-color': color,
            'box-shadow': `0 0 2px 2px ${color}`
          }"
        ></div>
      </div>
    </div>

    <div
      v-if="line"
      :class="'line ' + line + '-line'"
      :style="{ background: color }"
    >
      <p
        class="data-value"
        v-if="!isBlackListedId"
        :style="{ color: color }"
        v-html="dataValue"
      ></p>
      <div class="inner" :style="{ background: color }">
        <div
          class="inner-arrow"
          v-for="i in 4"
          :key="`${line}_${i}`"
          :class="line.split('-')[1]"
          :style="{ 'border-color': color }"
        ></div>
      </div>

      <div
        class="inner-circle"
        v-for="i in 4"
        :key="`single_${line}_${i}`"
        :style="{
          'background-color': color,
          'box-shadow': `0 0 2px 2px ${color}`
        }"
      ></div>
    </div>

    <div
      :class="'circle ' + line"
      :style="{
        'border-color': value == 0 ? 'rgba(0,0,0,0)' : color,
        'box-shadow': `0 0 6px 4px ${value == 0 ? 'rgba(0,0,0,0)' : color}`
      }"
    >
      <p v-if="title" class="the_title">{{ title }}</p>
      <div class="img-div">
        <img v-if="image" :src="image" :alt="title" />
        <img v-else src="@/assets/img/solar-panel.svg" :alt="title" />
      </div>
      <p class="the_value">
        {{
          value !== null || value !== undefined
            ? `${value == 0.001 ? 0 : value}${unit || "kW"}`
            : "no_value"
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-animated-icon",
  props: [
    "title",
    "value",
    "unit",
    "color",
    "image",
    "isCenterItem",
    "line",
    "lines",
    "dataValue",
    "isBlackListedId"
  ],
  components: {}
};
</script>

<style lang="scss" scoped>
.box {
  --width: 120px;
  --circle-size: 100px;
  --border-width: 0.5px;
  --device-width: 800px;
  --device-width: 320px;
  --line-width: 2px;
  --inner-circle-size: 5px;
  --inner-circle-margin: -1px;
  --inner-arrow-size: 5px;
  --inner-arrow-margin: -3px;

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    --width: 160px;
    --circle-size: 150px;
    --border-width: 0.5px;
    --device-width: 500px;
    --line-width: 5px;
    --inner-circle-size: 10px;
    --inner-circle-margin: -3px;
    --inner-arrow-size: 12px;
    --inner-arrow-margin: -3px;
  }

  display: flex;
  flex-direction: column;
  text-align: center;
  width: var(--width);
  position: relative;
}

.circle {
  border: var(--border-width) solid;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  width: var(--circle-size);
  height: var(--circle-size);
  align-items: center;
  justify-content: center;
  z-index: 20;
  background-color: #f9f9f9;
}

.img-div {
  width: 26px;
  margin-bottom: 10px;
  opacity: 0.4;

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    width: 40px;
  }
}
p {
  font-size: 1.2rem !important;
  padding-top: 5pt;
  // font-weight: bold;
}
.the_value {
  font-size: 1.2rem;
  color: #d19c47;
}

.the_title {
  margin-top: 10px;
  color: #949494;
  font-size: 1.2rem;
  @media (min-width: 950px) {
  }
}

.line {
  position: absolute;
  height: calc(var(--device-width) / 3.5);
  width: var(--line-width);
  background-color: lighten(#cccccc, 15%);
  transform-origin: top;
  margin: auto;
  left: 0;
  right: 0;
  display: none;
  top: var(--circle-size);

  .inner {
    display: block;
    // background: darken(#cccccc, .01%);
    width: 100%;
    opacity: 0.5;
    filter: alpha(opacity=50);
    height: 0%;
    animation: reducetime 1.5s infinite;
    animation-timing-function: ease-out;
  }

  .inner-circle {
    width: var(--inner-circle-size);
    height: var(--inner-circle-size);
    // background-color: rgba(250, 113, 111, 0.9);
    border-radius: 50%;
    margin-left: var(--inner-circle-margin);
    margin-top: 8px;
    // box-shadow: 0 0 2px 2px #f9ff9a;
  }

  .inner-arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    width: var(--inner-arrow-size);
    height: var(--inner-arrow-size);
    // background-color: rgba(250, 113, 111, 0.9);
    // border-radius: 50%;
    margin-left: var(--inner-arrow-margin);
    margin-top: var(--inner-arrow-margin);

    &.right {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }

    &.left {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }

    &.up {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }

    &.down {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }
}

.top-left-line {
  display: block;
  transform: rotate(-45deg);
  right: -0px;
  top: 90px;

  .inner {
    animation-delay: 1s;
  }

  .data-value {
    left: -59px;
    top: 36%;
    font-size: 8pt;
  }

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    right: -101px;
    top: 116px;
    transform: rotate(-58deg);
  }
}

.top-right-line {
  transform: rotate(45deg);
  display: block;
  left: -28px;
  top: 82px;

  .inner {
    animation-delay: 1.5s;
  }

  .data-value {
    transform: rotate(-90deg);
  }

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    transform: rotate(58deg);
    left: -128px;
    top: 112px;
  }
}

.bottom-left-line {
  transform: rotate(-145deg);
  display: block;
  right: -0;
  top: 60px;

  .inner {
    animation-delay: 1.5s;
  }

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    transform: rotate(-122deg);
    right: -123px;
    top: 60px;
  }
}

.data-value {
  transform: rotate(90deg);
  position: absolute;
  top: 35%;
  left: 5px;
}

.bottom-right-line {
  transform: rotate(145deg);
  display: block;
  right: 13px;
  top: 52px;

  .inner {
    animation-delay: 1.3s;
  }

  @media (min-width: 768px) and (max-width: 950px) {
  }

  @media (min-width: 950px) {
    transform: rotate(122deg);
    right: 137px;
    top: 46px;
  }
}

@keyframes reducetime {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customAnimatedIcon.vue